import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyBRL } from "../../../util/DoubleUtil";
import CantinaPageShared from "../CantinaPageShared";

const CantinaCreditoPageView = ({ pageCantinaCredito, handleChangePage, isLoading }) => (
  <CantinaPageShared
    page={pageCantinaCredito}
    isLoading={isLoading}
    loadingText="Carregando créditos..."
    emptyText="Nenhum crédito inserido."
    handleChangePage={handleChangePage}
  >
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Créditos da cantina">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Data e hora</TableCell>
            <TableCell align="right">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pageCantinaCredito.content.map((credito) => (
            <TableRow key={credito.codigo} hover>
              <TableCell>{dateTimeFormat(credito.dataHoraCredito)}</TableCell>
              <TableCell align="right">
                <Typography variant="body2" fontWeight={500} color="success.main">
                  + {currencyBRL(credito.valorCredito)}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </CantinaPageShared>
);

export default CantinaCreditoPageView;
